import React from 'react';
import { wrapExpressionForRender } from 'services/React-Utils';

const If = ({ test, children, component: ChildComponent, ...restProps }) =>
  !test ? null : ChildComponent ? (
    <ChildComponent {...restProps} />
  ) : (
    wrapExpressionForRender(children)
  );

export default If;
